import { instanceOf } from 'prop-types';

import { rem } from '@blueprint/ui';

import { MessageTime } from 'components/message-meta/MessageTime';

export const ReplyMetaTime = ({ datetime }) => (
  <MessageTime
    datetime={datetime}
    aria-hidden
    marginLeft={rem(8)}
    marginTop={rem(4)}
  />
);

ReplyMetaTime.propTypes = {
  /**
   * Datetime of the reply
   */
  datetime: instanceOf(Date).isRequired,
};
